module.exports = __webpack_public_path__ + "src/assets/games/21/179.jpg";